import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { avatarsAPI } from '../services/api';
import { markRelationCaptured, unwrapMemberRelationPayload } from '../utils/freeTrial';
import { RELATION_OPTIONS } from '../constants/relations';
import './RelationCaptureScreen.css';

const RelationCaptureScreen = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const avatarId = searchParams.get('avatar_id');

  const [avatarName, setAvatarName] = useState('');
  const [selected, setSelected] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [dismissCount, setDismissCount] = useState(0);

  // Load avatar info
  useEffect(() => {
    if (!avatarId) {
      navigate('/chat');
      return;
    }

    const load = async () => {
      try {
        const relStatus = await avatarsAPI.getMemberRelation(avatarId);
        const data = unwrapMemberRelationPayload(relStatus);
        const uid = sessionStorage.getItem('user_id');

        if (data?.relation != null && String(data.relation).trim() !== '') {
          if (uid) markRelationCaptured(uid, avatarId);
          navigate('/chat', { replace: true });
          return;
        }

        if (data?.needs_capture === false) {
          if (uid) markRelationCaptured(uid, avatarId);
          navigate('/chat', { replace: true });
          return;
        }

        setAvatarName(data?.avatar_name || 'your loved one');
        setDismissCount(data?.dismiss_count || 0);
      } catch (_) {
        navigate('/chat');
      }
    };

    load();
  }, [avatarId, navigate]);

  const handleBegin = async () => {
    if (!selected) return;
    setSubmitting(true);
    try {
      await avatarsAPI.setMemberRelation(avatarId, selected);
      try {
        const uid = sessionStorage.getItem('user_id');
        if (uid) markRelationCaptured(uid, avatarId);
      } catch (_) { /* ignore */ }
      navigate('/chat');
    } catch (_) {
      navigate('/chat');
    }
  };

  const handleDismiss = async () => {
    try {
      await avatarsAPI.dismissMemberRelation(avatarId);
    } catch (_) {
      // best-effort
    }
    try {
      const uid = sessionStorage.getItem('user_id');
      if (uid) markRelationCaptured(uid, avatarId);
    } catch (_) { /* ignore */ }
    navigate('/chat');
  };

  return (
    <div className="relation-capture-screen">
      <div className="relation-capture-card">
        {dismissCount < 2 && (
          <button
            className="relation-capture-close"
            onClick={handleDismiss}
            aria-label="Skip for now"
          >
            &#10005;
          </button>
        )}

        <h1 className="relation-capture-heading">Before you begin</h1>
        <p className="relation-capture-subheading">
          You are <strong>{avatarName}</strong>'s
        </p>

        <div className="relation-capture-select-wrapper">
          <select
            className="relation-capture-select"
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
          >
            <option value="">Select relationship…</option>
            {RELATION_OPTIONS.map((r) => (
              <option key={r.value} value={r.value}>
                {r.label}
              </option>
            ))}
          </select>
        </div>

        <button
          className="relation-capture-btn"
          onClick={handleBegin}
          disabled={!selected || submitting}
        >
          Begin
        </button>
      </div>
    </div>
  );
};

export default RelationCaptureScreen;
